var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-main-content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12" }, [
          _c(
            "div",
            { staticClass: "form-box" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("v-app", [
                _c("div", { staticClass: "card-item p-3 row ml-5" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-4 responsive-column" },
                    [
                      _c("v-autocomplete", {
                        staticClass: "pl-4",
                        attrs: {
                          filter: _vm.filterAgencies,
                          items: _vm.agencyList,
                          flat: "",
                          "hide-no-data": "",
                          "hide-details": "",
                          "item-value": "id",
                          placeholder: "Acente",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function (ref) {
                              var item = ref.item
                              var selected = ref.selected
                              return [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(item.name) +
                                    "\n                    "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item",
                            fn: function (ref) {
                              var item = ref.item
                              var tile = ref.tile
                              return [
                                _c("v-list-tile-content", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(item.name) +
                                      "\n                      "
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.selectedAgency,
                          callback: function ($$v) {
                            _vm.selectedAgency = $$v
                          },
                          expression: "selectedAgency",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-lg-4 responsive-column" },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.sailList,
                          "item-value": "id",
                          "item-text": "email",
                          label: "Sefer",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function (data) {
                              return [
                                _c("div", { staticStyle: { width: "30%" } }, [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm._f("ddMMyyyy")(data.item.sailDate)
                                      ) +
                                      "\n                      "
                                  ),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "item",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm._f("ddMMyyyy")(data.item.sailDate)
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.selectedSail,
                          callback: function ($$v) {
                            _vm.selectedSail = $$v
                          },
                          expression: "selectedSail",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-item p-3" }, [
                  _c("div", { staticClass: "table-form table-responsive" }, [
                    _c("table", { staticClass: "table" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [_vm._v("Acente")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Sefer")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Tutar")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Proforma Fatura No")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Proforma Üretim Tarihi")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Proforma İptal Tarihi")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Proforma İndir")]),
                          _vm._v(" "),
                          _c(
                            "th",
                            { staticStyle: { "background-color": "#00bfa5" } },
                            [_vm._v("Fatura Fatura No")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            { staticStyle: { "background-color": "#00bfa5" } },
                            [_vm._v("Fatura Fatura Durumu")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            { staticStyle: { "background-color": "#00bfa5" } },
                            [_vm._v("Fatura Üretim Tarihi")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            { staticStyle: { "background-color": "#00bfa5" } },
                            [_vm._v("Fatura İptal Tarihi")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            { staticStyle: { "background-color": "#00bfa5" } },
                            [_vm._v("Fatura Ödeme Tarihi")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            { staticStyle: { "background-color": "#00bfa5" } },
                            [_vm._v("Fatura İndir")]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(
                          _vm.proformaInvoices.filter(function (a) {
                            return (
                              (a.agencyId == _vm.selectedAgency ||
                                _vm.selectedAgency == 0) &&
                              (a.sailId == _vm.selectedSail ||
                                _vm.selectedSail == 0)
                            )
                          }),
                          function (proformaInvoice) {
                            return _c(
                              "tr",
                              { key: proformaInvoice.invoiceInvoiceId },
                              [
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.agencyMap[proformaInvoice.agencyId]
                                        .name
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("ddMMyyyy")(
                                        _vm.sailsLiteMap[proformaInvoice.sailId]
                                          .sailDate
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("toCurrency")(
                                        proformaInvoice.proformaTotalAmount
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "clickable-text" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          _vm.basePath +
                                          "/proforma-detail/" +
                                          proformaInvoice.proformaId,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          proformaInvoice.proformaInvoiceId
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                proformaInvoice.proformaCreateDate
                                  ? _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("ddMMyyyyHHmm")(
                                            proformaInvoice.proformaCreateDate
                                          )
                                        )
                                      ),
                                    ])
                                  : _c("th"),
                                _vm._v(" "),
                                proformaInvoice.proformaCancelDate
                                  ? _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("ddMMyyyyHHmm")(
                                            proformaInvoice.proformaCancelDate
                                          )
                                        )
                                      ),
                                    ])
                                  : _c("th"),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "clickable-text",
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadProforma(
                                          proformaInvoice.proformaId
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("indir")]
                                ),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(proformaInvoice.invoiceInvoiceId)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  [
                                    _c("invoice-status", {
                                      attrs: {
                                        "invoice-status":
                                          proformaInvoice.invoiceStatus,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                proformaInvoice.invoiceCreateDate
                                  ? _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("ddMMyyyyHHmm")(
                                            proformaInvoice.invoiceCreateDate
                                          )
                                        )
                                      ),
                                    ])
                                  : _c("th"),
                                _vm._v(" "),
                                proformaInvoice.invoiceCancelDate
                                  ? _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("ddMMyyyyHHmm")(
                                            proformaInvoice.invoiceCancelDate
                                          )
                                        )
                                      ),
                                    ])
                                  : _c("th"),
                                _vm._v(" "),
                                proformaInvoice.invoicePaidDate
                                  ? _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("ddMMyyyyHHmm")(
                                            proformaInvoice.invoicePaidDate
                                          )
                                        )
                                      ),
                                    ])
                                  : _c("th"),
                                _vm._v(" "),
                                proformaInvoice.invoiceStatus != null
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "clickable-text",
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadInvoice(
                                              proformaInvoice.invoiceId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        indir"
                                        ),
                                      ]
                                    )
                                  : _c("th"),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-title-wrap" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-between" },
        [_c("h3", { staticClass: "title" }, [_vm._v("Proforma/Fatura Detay")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }